var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 1a2 2 0 0 0-2 2v7h2V3h22v7h2V3a2 2 0 0 0-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 11a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a5 5 0 0 1 5 5v7a3 3 0 0 1-3 3h-1v3a1 1 0 1 1-2 0v-3H6v3a1 1 0 1 1-2 0v-3H3a3 3 0 0 1-3-3v-7a5 5 0 0 1 5-5h2zm2 1h4v-1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1zm14 0v-1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1zM2 17a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1h26v-2H2z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})))));
export default SvgBed;